import { ChangeDetectorRef, Component, Input, OnChanges } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ConfigService } from '../../../services/config/config.service';
import { NotifyService } from '../../../services/notify/notify.service';
import { HttpErrorResponse } from '@angular/common/http';

@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.scss'],
  standalone: false,
})
export class MenuComponent implements OnChanges {
  items: any = [];
  menu: Array<any> = [];
  menuTemp: Array<any> = [];
  infoUser: any = {};
  infoEmpresa: any = {};
  infoParametrizacion: any = {};
  display: boolean = false;
  token: any = {};
  @Input() title: string = "";
  // canal de comunicación entre pestañas
  channel = new BroadcastChannel('channelSession');

  @Input() hasChanges: boolean = false;
  constructor(private config: ConfigService, private router: ActivatedRoute, private route: Router,
    private notify: NotifyService,
    private cdf: ChangeDetectorRef
  ) {


    if (!localStorage.getItem('token')) {
      this.route.navigate(['/auth']);
      this.channel.postMessage('reload');
    }

    // listen Channel
    this.channel.onmessage = (event) => {
      if (event.data == 'reload') {
        window.location.reload();
      }
    }

  }

  ngOnChanges(): void {
    if (!localStorage.getItem('token')) {
      this.route.navigate(['/auth']);
      this.channel.postMessage('reload');
    }
    else {
      this.infoUser = JSON.parse(localStorage.getItem('infoUser') ?? "[]") as Object;
      this.infoEmpresa = JSON.parse(localStorage.getItem('empresa') ?? "[]") as Object;

      this.infoParametrizacion = JSON.parse(localStorage.getItem('parametros') ?? "");

      this.token = JSON.parse(localStorage.getItem('token') ?? "".toString());

      //  ************ en caso de ser un perfil administrador se debe subscribir a los cambios para monitoreo ******
      if (this.infoUser?.idPerfilNavigation?.isAdm == 1) {
        /* this.notify.subscribeService(this.token.token).subscribe({
          next: (data: any) => {
            console.log(data);
            this.cdf.detectChanges();
          },
          error: (error: HttpErrorResponse) => {
            console.log(error);
          }
        }); */
      }
      // ***********************************************************************************************************

      if (!!localStorage.getItem('menu')) {
        this.menuTemp = JSON.parse(localStorage.getItem('menu') ?? "");
        // información emporal para armar el menu
        let menu: Array<any> = [];
        menu.push({
          label: "Inicio",
          icon: "pi pi-home",
          url: "auth",
          target: "_parent",
        });

        this.menuTemp.map((row: any) => {
          let index = menu.findIndex(item => { return row.idLinkNavigation.idMenuNavigation.idMenu == item.id });
          if (index == -1)
            menu.push({
              id: row.idLinkNavigation.idMenuNavigation.idMenu,
              label: row.idLinkNavigation.idMenuNavigation.nombreMenu,
              icon: row.idLinkNavigation.idMenuNavigation.icon,
              url: row.idLinkNavigation.idMenuNavigation.url,
              target: "_parent",
              items: [{
                label: row.idLinkNavigation.nombreLink,
                url: row.idLinkNavigation.route,
                target: "_parent",
                icon: row.idLinkNavigation.icon
              }]
            });
          else
            menu[index].items.push({
              label: row.idLinkNavigation.nombreLink,
              url: row.idLinkNavigation.route,
              target: "_parent",
              icon: row.idLinkNavigation.icon
            })
        });

        this.menu = menu;


        let arrayTemp = this.menu.map(row => {
          return !row.url ? (row.items.map((item: any) => { return item.url })) : row.url
        });

        let array: Array<any> = [];

        arrayTemp.map((row: any) => {
          if (Array.isArray(row)) {
            row.map((item: any) => {
              array.push(item);
            })
          }
          else
            array.push(row);
        });
        // validaciòn if url is valid

        this.router.url.subscribe(dat => {
          let route = dat.map(row => { return row.path }).join('/');
          const noRestrictedVar = array.filter((row: any) => {
            //console.log((row ?? "").split('/').slice(-1)[0], route.split("/").slice(-1)[0])
            return (row ?? "").split('/').slice(-1)[0] == route.split("/").slice(-1)[0]
          })

          if ((noRestrictedVar.length == 0) && (route != 'index') && (route != 'index_adm') && (route != 'pagos_servicio')
            && (route != 'AsignacionVendedores') && (route != 'Flete')
            && (route.split("/")[0] != 'detalle_cotizacion') && (route.split("/")[0] != 'sales-ecommerce'))

            window.location.href = this.config.urlHome + "loss";
        });
      }
    }
  }



  closeSession() {
    this.config.closeOfSession(true);
    this.channel.postMessage('reload');
  }

}
